import { render } from "./Headline.vue?vue&type=template&id=942a84b4&ts=true"
import script from "./Headline.vue?vue&type=script&lang=ts"
export * from "./Headline.vue?vue&type=script&lang=ts"

import "./Headline.vue?vue&type=style&index=0&id=942a84b4&lang=scss"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__